import store from "@/store/index";
import { AxiosError, AxiosRequestConfig, AxiosResponse } from "axios";
import { HttpInterface } from "@/services/http";
import ErrorHandler from "@/services/error-handler/http";

class Interceptor {
  public static request(httpInstance: HttpInterface): void {
    httpInstance.getAxiosInstance().interceptors.request.use(
      async (config: AxiosRequestConfig) => {
        const queryConfig: AxiosRequestConfig = config;
        const credentials: CredentialsInterface =
          store.getters["authentication/credentials"];

        if (!httpInstance.getPreloaderState()) {
          await store.dispatch("preloader/show");
        }

        if (credentials.token) {
          queryConfig.headers.Authorization = `Bearer ${credentials.token}`;
        }

        queryConfig.headers["x-localization"] =
          store.getters["localization/getCurrent"];

        return queryConfig;
      },
      (error: AxiosError) => {
        return Promise.reject(error);
      }
    );
  }

  public static response(httpInstance: HttpInterface): void {
    httpInstance.getAxiosInstance().interceptors.response.use(
      async (response: AxiosResponse) => {
        await store.dispatch("preloader/hide");
        return response;
      },
      async (error: AxiosError) => {
        const errorHandler = new ErrorHandler(
          httpInstance.getIgnoredErrors(),
          error.response?.request
        );

        try {
          await errorHandler.handle();
        } catch {
          await Promise.resolve();
        }

        await store.dispatch("preloader/hide");
        if (error.response && error.response.status >= 400) {
          return Promise.reject(error.response);
        }
        return Promise.resolve(error.response);
      }
    );
  }
}

export default Interceptor;
